


















import { VISUALIZATIONS } from '@/constants/DashboardConstants';

import HorizontalBarChart from './HorizontalBarChart.vue';
import VerticalBarChart from './VerticalBarChart.vue';
import PieChart from './PieChart.vue';
import RichText from './RichText.vue';

const { VERTICAL_BAR_CHART, HORIZONTAL_BAR_CHART, PIE_CHART, RICH_TEXT } = VISUALIZATIONS;

const VISUALIZATION_COMPONENTS = {
  [VERTICAL_BAR_CHART]: VerticalBarChart,
  [HORIZONTAL_BAR_CHART]: HorizontalBarChart,
  [PIE_CHART]: PieChart,
  [RICH_TEXT]: RichText,
};

export interface SeriesItemProp {
  label?: string;
  color?: string;
  value: number;
}

export default {
  name: 'Visualization',
  components: {
    VerticalBarChart,
    HorizontalBarChart,
    PieChart,
  },
  props: {
    settings: {
      type: Object,
      required: true,
    },
    series: {
      type: Array as () => SeriesItemProp[],
      default: [],
    },
    textContent: {
      type: String,
      default: () => null,
    },
  },
  computed: {
    visualizationComponent() {
      const { visualization } = this.settings;
      return VISUALIZATION_COMPONENTS[visualization];
    },
  },
};
